import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { TMChangeOrderAPI } from '@business/api/tm_change_order';
import { ChangeOrderFormData } from '@modules/timeMaterials/AddEditTMChangeOrderPage/TMChangeOrderForm';
import { OrderEmailTemplateRequest, TMChangeOrderId, TMChangeOrderResponse } from '@business/entities/tm';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';

export class TMChangeOrderBloc extends BaseBloc {
  private readonly itemRepo = new Repository<TMChangeOrderResponse>({
    getItemId: item => item.id,
  });

  readonly orders$ = this.itemRepo.items$;
  readonly selectOrder = this.itemRepo.selectItem;

  onReset() {
    this.itemRepo.reset();
  }

  fetchChangeOrders = (tmId: string) => {
    return TMChangeOrderAPI.fetchChangeOrders(tmId).pipe(this.itemRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_order_error') }));
  };

  fetchChangeOrder = (id: TMChangeOrderId) => {
    return TMChangeOrderAPI.fetchChangeOrder(id).pipe(
      this.itemRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_order_error') }),
    );
  };

  createOrder = (data: ChangeOrderFormData) => {
    return TMChangeOrderAPI.createOrder(data).pipe(
      //   this.itemRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_order'),
      }),
    );
  };

  deleteCO = (id: TMChangeOrderId) => {
    return showDeleteConfirmation('Delete Change Order', 'Do you really want to remove this change order?').pipe(
      switchMap(() => TMChangeOrderAPI.deleteCO(id)),
      this.itemRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_order'),
      }),
    );
  };

  sendCO = (id: TMChangeOrderId, data: OrderEmailTemplateRequest) => {
    return TMChangeOrderAPI.sendCO(id, data).pipe(
      handleMessage({
        type: requestMessage('create_order'),
      }),
    );
  };

  onSigned = (id: TMChangeOrderId, sign: string, amount: number) => {
    return TMChangeOrderAPI.onSigned(id, sign, amount).pipe(
      this.itemRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('create_order'),
      }),
    );
  };
}
